// extracted by mini-css-extract-plugin
export var center = "_5g-2";
export var clickableRow = "_5g-5";
export var expandedRow = "_5g-7";
export var hoverable = "_5g-4";
export var left = "_5g-1";
export var right = "_5g-3";
export var row = "_5g-0";
export var selectedRow = "_5g-6";
export var summaryRow = "_5g-8";